/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSessionDataModel } from '../../models/patient-session-data-model';

export interface GetSessionEntriesForTarget$Params {
  patientID?: number;
  targetID?: number;
  startTime?: string;
  endTime?: string;
  sparkModeIDs?: Array<number>;
}

export function GetSessionEntriesForTarget(http: HttpClient, rootUrl: string, params?: GetSessionEntriesForTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetSessionEntriesForTarget.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('targetID', params.targetID, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
    rb.query('sparkModeIDs', params.sparkModeIDs, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientSessionDataModel>>;
    })
  );
}

GetSessionEntriesForTarget.PATH = '/api/Graph/GetSessionEntriesForTarget';
